'use client'

import { useEffect, useState } from 'react'
import type { BannerMessagesQuery } from '@/generated/graphql'

const DURATION = 7000

export const RotatingBanner = ({ className, items }: RotatingBannerProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  const currentItem = items[currentIndex]

  useEffect(() => {
    const timer = setInterval(() => {
      setIsTransitioning(true)
    }, DURATION)

    return () => clearInterval(timer)
  }, [])

  const updateIndex = (e: React.TransitionEvent<HTMLDivElement>) => {
    if (e.target !== e.currentTarget || e.propertyName !== 'opacity') return
    if (isTransitioning) {
      setCurrentIndex(prevIndex =>
        prevIndex === items.length - 1 ? 0 : prevIndex + 1
      )

      setIsTransitioning(false)
    }
  }

  return (
    <div className={`w-full flex items-center h-full ${className}`}>
      {currentItem ? (
        <div
          className={`text-white text-sm pt-1 flex items-center transition-opacity duration-300 ${isTransitioning ? 'opacity-0' : 'opacity-100'}`}
          onTransitionEnd={updateIndex}
          dangerouslySetInnerHTML={{ __html: currentItem.html ?? '' }}
        />
      ) : null}
    </div>
  )
}

interface RotatingBannerProps {
  items: BannerMessagesQuery['bannerMessages']
  className?: string
}
